var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-wrapper"},[_c('div',{staticClass:"cube-wrapper"},[_c('div',{staticClass:"cube-folding"},[_c('span',{staticClass:"leaf1"}),_c('span',{staticClass:"leaf2"}),_c('span',{staticClass:"leaf3"}),_c('span',{staticClass:"leaf4"})])])])
}]

export { render, staticRenderFns }